import { CREATE_USER_FORM_SUPPLIER_WISE_REPORT, FETCH_SUPPLIER_NAME_LIST_DATA_FAILURE, 
    FETCH_SUPPLIER_NAME_LIST_DATA_REQUEST, FETCH_SUPPLIER_NAME_LIST_DATA_SUCCESS,
     FETCH_SUPPLIER_PARTY_DETAIL_FAILURE, FETCH_SUPPLIER_PARTY_DETAIL_REQUEST, 
     FETCH_SUPPLIER_PARTY_DETAIL_SUCCESS, FETCH_SUPPLIER_WISE_REPORTS_DATA_FAILURE,
      FETCH_SUPPLIER_WISE_REPORTS_DATA_REQUEST, FETCH_SUPPLIER_WISE_REPORTS_DATA_SUCCESS,
        FETCH_SUPPLIER_WISE_DTL_REPORTS_DATA_REQUEST, FETCH_SUPPLIER_WISE_DTL_REPORTS_DATA_SUCCESS,
    FETCH_SUPPLIER_WISE_DTL_REPORTS_DATA_FAILURE
    } from "./supplierWiseReport.actionType";

export const SUPPLIER_WISE_REPORT = 'supplierreports';

let initialState = {
    loading: false,
    supplierReportData: [],
    supplierDtlReportData: [],
    supplierNameData: [],
    supplierWiseUserform: {
        fldFKUnitId: '',
        fldId: '',
        fldName: '',
    },
    supplierPartyDetailList: [],
};

export let supplierWiseReportsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SUPPLIER_WISE_REPORTS_DATA_REQUEST:
        case FETCH_SUPPLIER_WISE_DTL_REPORTS_DATA_REQUEST:
        case FETCH_SUPPLIER_NAME_LIST_DATA_REQUEST:
        case FETCH_SUPPLIER_PARTY_DETAIL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_USER_FORM_SUPPLIER_WISE_REPORT:
            return {
                ...state,
                loading: false,
                supplierWiseUserform: {
                    ...state.supplierWiseUserform,
                    [payload.key]: payload.value
                }
            }
        case FETCH_SUPPLIER_WISE_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierReportData: updatePayload
            };
         case FETCH_SUPPLIER_WISE_DTL_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierDtlReportData: updatePayload
            };
        case FETCH_SUPPLIER_PARTY_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierPartyDetailList: updatePayload
            };
        case FETCH_SUPPLIER_NAME_LIST_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierNameData: updatePayload
            };

        case FETCH_SUPPLIER_WISE_REPORTS_DATA_FAILURE:
        case FETCH_SUPPLIER_WISE_DTL_REPORTS_DATA_FAILURE:
        case FETCH_SUPPLIER_NAME_LIST_DATA_FAILURE:
        case FETCH_SUPPLIER_PARTY_DETAIL_FAILURE:
            return {
                ...state,
                loading: false
            };


        default:
            return state;
    }
};